import Icon from "../../../../components/Icon/Icon";
import FormButton, {DetButton} from "../../../../components/Form/Button/FormButton";
import {GrFormNext, GrFormPrevious} from "react-icons/gr";
import {useAnswerModal} from "../../../../Modals/BaseModal/Context";
import {useNavigate} from "react-router-dom";
import {useQuestion} from "../../../../redux/Reducers/QuestionReducer";
import {useEffect, useState} from "react";

function getRoute(name,num){
    name = name.toLowerCase().split(" ").join("-")
    // if the last character is  - then remove it
    if(name[name.length-1]==="-"){
        name = name.slice(0,name.length-1)
    }
    return `/practice/${name}/${num}`
}

export default function QuestionFooter({className,loading,disabled, onRetryClick,onClickSubmit, ...props}) {
    const navigate = useNavigate()
    const {question} = useQuestion()

    const [isPrev, setIsPrev] = useState(false)
    const [isNext, setIsNext] = useState(false)
    useEffect(() => {
        setIsPrev(question?.metaData?.prev ? true : false)
        setIsNext(question?.metaData?.next ? true : false)
    }, [question])

    return (
        <div className={`flex flex-row gap-4  items-center ${className}`}>

            <div className={"flex  gap-2 md:gap-8"}>
                <div onClick={props?.onRetryClick ? props.onRetryClick : ()=>{
                    window.location.reload()

                }}
                     className={"flex-row justify-center items-center cursor-pointer flex gap-2"}>
                    <Icon name={"retry"} className={" w-4"}/>
                    <p className={"font-semibold whitespace-nowrap"}>
                        Retry Now
                    </p>
                </div>




            </div>

            <div className={"flex flex-1 flex-col text-2xl justify-center items-center text-white  gap-2"}>

                <div className={"flex  flex-row-reverse  w-full  gap-5"}>

                    <div className={` w-10 flex cursor-pointer justify-center items-center rounded-sm 
                    ${isNext ? "bg-secondary-900" : "bg-secondary-300"}
                    `}
                         onClick={()=>{
                             if(isNext) {
                                 let url = window.location.href
                                 url = url.split("/practice").pop()
                                 let lastPart = url.split("/").pop()

                                 let newUrl = url.replace(lastPart, question?.metaData?.next)
                                 newUrl = getRoute(question?.route_name || question?.metaData?.next.name,question?.metaData?.next.id)
                                 window.location.href = newUrl
                             }

                         }}
                    >
                        <GrFormNext/>
                    </div>
                    <div
                        className={`w-10 flex cursor-pointer justify-center items-center rounded-sm 
                        ${isPrev ? "bg-secondary-900" : "bg-secondary-300"}
                        `}
                        onClick={() => {
                        //     get current url
                            if(isPrev) {
                                let url = window.location.href
                                url = url.split("/practice").pop()
                                let lastPart = url.split("/").pop()
                                let newUrl = url.replace(lastPart, question?.metaData?.prev)
                                newUrl = getRoute(question?.route_name || question?.metaData?.prev.name,question?.metaData?.prev.id)
                                window.location.href = newUrl
                            }
                        }}
                    >
                        <GrFormPrevious/>
                    </div>
                    <DetButton
                        onClick={onClickSubmit}
                        loading={loading}
                        disabled={disabled}
                        id={"submit-question-button"}
                        className={"w-full lg:w-[15%] py-2 sm:rounded-md md:rounded-md"} {...props}>
                        {props?.submitText? props.submitText : "Submit"}
                    </DetButton>


                </div>
            </div>

        </div>

    )
}
